import React from 'react';
import Link from '../../Link';
import Logo from '../../Logo/Logo';
import { DefaultLinks } from './Common';
import MobileMenu from './MobileMenu';

import Styles from '../Header.module.scss';

const Default = ({ analyticsData, buttonLabel }) => {
  return (
    <React.Fragment>
      <Link href='/' className={Styles.logoLink} title={`${process.env.NEXT_PUBLIC_SITE_NAME}`}>
        <Logo className={Styles.logo} />
        <h2 className={Styles.logoSuffix}>{`INSIGHTS`}</h2>
      </Link>
      <MobileMenu>
        <DefaultLinks>
          <Link
            className={Styles.primaryButton}
            title=''
            href={{
              pathname: '/company/register',
              query: { ...analyticsData },
            }}>
            {buttonLabel || 'Work With Talents'}
          </Link>
        </DefaultLinks>
      </MobileMenu>
    </React.Fragment>
  );
};

export default Default;
